module.exports = __webpack_public_path__ + "static/media/7.e43f55ff.png";